<template>
    <div class="count-container">
        <div class="score-region" v-if="activeScreen != 'ask'">
            <div class="score-icon"></div>
            <div class="score-box" v-if="activeScreen != 'threat'">
                <div class="score-title">互联网基础设施综合安全评分</div>
                <div class="local-icon">
                    <img src="../assets/headerCount/local-icon.png">
                </div>
                <div class="local-text">国内</div>
                <div class="local-score">{{ownScore}}</div>
                <div class="local-text">分</div>
                <div class="global-icon">
                    <img src="../assets/headerCount/global-icon.png">
                </div>
                <div class="local-text">全球</div>
                <div class="local-score">{{globalScore}}</div>
                <div class="local-text">分</div>
            </div>
          <div class="score-box" v-if="activeScreen == 'threat'">
            <div class="score-title">高倍率域名解析流量放大攻击TSUKING</div>
          </div>
        </div>
        <div class="count-region" v-if="activeScreen != 'ask'">
            <div class="count-symbol-one" v-if="activeScreen != 'threat'">
                <img src="../assets/headerCount/count-symbol-one.png">
            </div>
            <div class="count-box" v-if="activeScreen != 'threat'">
                <div class="count-title-one count-title">全球安全监测节点数据</div>
                <div class="count-num">{{dotNum}}</div>
                <div class="count-text">个</div>
            </div>
            <div class="count-symbol-one" v-if="activeScreen != 'threat'">
                <img src="../assets/headerCount/count-symbol-two.png">
            </div>
            <div class="count-box" v-if="activeScreen != 'threat'">
                <div class="count-title-two count-title">监测机构数量</div>
                <div class="count-num">{{institutionNum}}</div>
                <div class="count-text">个</div>
            </div>
            <div class="count-symbol-one">
                <img src="../assets/headerCount/count-symbol-three.png">
            </div>
            <div class="count-box" v-if="activeScreen != 'threat'">
                <div class="count-title-three count-title">安全风险知识库规模</div>
                <div class="count-num">{{vulNum}}</div>
                <div class="count-text">个</div>
            </div>
            <div class="count-box" v-if="activeScreen == 'threat'">
              <div class="count-title-four count-title">风险评级</div>
              <div class="count-num">{{level}}</div>
              <div class="count-title-four count-title">影响全球</div>
              <div class="count-num">{{percent}}%</div>
              <div class="count-text">系统规模</div>
            </div>
        </div>

      <div class="searchInput" v-if="activeScreen === 'ask' && chatShow === true">
        <div>
          <el-input placeholder="漏洞搜索" v-model="searchInput" class="input-with-select">
            <el-button @click="jumpChat" slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>
      </div>
    </div>
</template>

<script>
import {getModuleScore, getMonitoringData, getThreatsLevel} from "@/service/dashboard";
import store from "@/store";
export default {
  name: "dp-count",
  props: ["activeScreen", "chatShow"],
  data(){
    return {
      searchInput: "",
      ownScore: 0,
      globalScore: 0,
      dotNum: 0,
      institutionNum: 0,
      vulNum: 0,
      origin: {},
      levelDict: [
        {
          key: "CRITICAL",
          value: "极高"
        },
        {
          key: "HIGH",
          value: "高"
        },
        {
          key: "MEDIUM",
          value: "中"
        }
      ]
    };
  },
  created() {
    this.getScore();
    this.getCount();
    this.getLevel();
  },
  computed: {
    level() {
      if (this.origin[store.state.dict.threatId]) {
        const content = this.origin[store.state.dict.threatId];

        return this.levelDict.find(i => i.key === content.val)?.value?? "未知";
      }
      return "未知";
    },
    percent() {
      if (this.origin[store.state.dict.threatId]) {
        const content = this.origin[store.state.dict.threatId];

        return (content.percentage * 100).toFixed(2);
      }
      return 0;
    }
  },
  methods: {
    getScore() {
      getModuleScore().then(res => {
        this.ownScore = res.cn;
        this.globalScore = res.ww;
      });
    },
    getCount() {
      getMonitoringData().then(res => {
        this.dotNum = res.vp_count;
        this.institutionNum = res.ent_count;
        this.vulNum = res.vul_count;
      });
    },
    getLevel() {
      getThreatsLevel().then(res => {
        this.origin = res;
      });
    },
    jumpChat() {
      this.$emit("jumpChatEmit", this.searchInput);
    }
  }
};
</script>

<style scoped lang="less">
.count-container {
  width: 95%;
    position: absolute;
    top: 135px;
    left: 58px;
    display: flex;
    justify-content: space-between;
    .score-region {
        display: flex;
        .score-icon {
            width: 59px;
            height: 54px;
            background-size: 82px 60px;
            background-image: url("../assets/headerCount/score-icon.png");
            background-repeat: no-repeat;
            background-position-x: -11.5px;
            background-position-y: top;
        }
        .score-box {
            //width: 888px;
            padding: 0 30px 0 26px;
            height: 54px;
            background-size: 100% 100%;
            background-image: url("../assets/headerCount/score-box-bg.png");
            background-repeat: no-repeat;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            font-size: 28px;
            font-family: YouSheBiaoTiHei;
            .score-title {
              height: 54px;
              line-height: 54px;
                color: #FFF;
                text-shadow: 0 2px 20px 0 #2A38B4;
                padding-right: 22px;
            }
            .local-icon {
                width: 31px;
                height: 30px;
                padding-right: 6px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .local-text {
                color: #E4E4FF;
                margin-right: 6px;
            }
            .local-text:nth-last-child(1){
                 padding-right: 26px;
            }
            .local-score {
                color: #D4C9FF;
                font-size: 30px;
                margin-right: 6px;
                position: relative;
                .double-score {
                    position: absolute;
                    color: #F1EDFF;
                    top:0;
                    z-index: -1;
                }
            }
            .global-icon {
                width: 30px;
                height: 30px;
                margin-left: 31px;
                margin-right: 6px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
    .count-region {
        display: flex;
        align-items: center;
        .count-symbol-one {
            width: 50px;
            height: 59px;
            margin-right: 12px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .count-box {
            background-color: black;
            height: 54px;
            box-sizing: border-box;
            padding-top: 9px;
            padding-bottom: 9px;
            padding-left: 16px;
            padding-right: 8px;
            font-family: YouSheBiaoTiHei;
            color: #FFF;
            display: flex;
            margin-right: 30px;
          clip-path: polygon(
              4% 0%,            /* 矩形左上角 */
              0 0%, /* 矩形右上中间 */
              100% 0%,          /* 矩形右上角 */
              100% 100%,        /* 矩形右下角 */
              0 100%, /* 矩形右下中间 */
              4% 100%,          /* 矩形左下角 */
              0% 85%, /* 矩形左下角被切掉的部分*/
              0	18%
          );
            border: 1px solid transparent;
            border-image: linear-gradient(45deg, rgba(170, 173, 235, 1), black) 1;
            .count-title-one {
                width: 86px;
            }
            .count-title-two {
                width: 55px
            }
            .count-title-three {
                width: 85px
            }
            .count-title-four {
              width: 35px
            }
            .count-title {
                font-size: 18px;
                line-height: 18px;
                margin: 0 4px;
            }
            .count-num {
                color: #D4C9FF;
                font-size: 25px;
                align-self: center;
                margin-left: 7px;
                margin-right: 4px;
            }
            .count-text {
                font-size: 14px;
                align-self: flex-end;
            }
        }
    }
  .searchInput{
    width: 875px;
    height: 45px;
    position: absolute;
    left: 518px;
    top: 30px;
    .bug{
      position: absolute;
      color: #fff;
      left: 15px;
      top: 8px;
      font-size: 20px;
      margin: 0 4px;
    }
    img{
      width: 875px;
      height: 45px;
    }

    .searchLogo{
      width: 20px;
      position: absolute;
      right: 15px;
      top: 11px;
      img{
        width: 100%;
        height: 20px;
      }
    }
  }
}
/deep/.el-input__inner {
  background-color: #273264;
  border: 1px solid #c1c2fe;
  border-right: none;
  color: #fff;
}
/deep/.el-input-group__append {
  background-color: #273264;
  border: 1px solid #c1c2fe;
  border-left: none;
  color: #fff;
}

</style>
